import React from 'react'
import { Page, Empty } from '../components'

export const EmptyService: React.FC = () => (
  <Page>
    <Empty />
  </Page>
)
